export { CommonContentTable } from './CommotContentTable';
export type { EditAction } from './CommotContentTable';
